import { format } from "date-fns";
import locale from "date-fns/locale/ja";

export default function formatDay(d: Date): string {
  return format(d, "E", { locale });
}
